import FloatingActionDescription from './FloatingActionDescription';

export default FloatingActionDescription;
